import React from "react";
import { ArrowLeft } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

export default function Products({ products = [], onNavigate, onProductClick }) {
  const { t } = useI18n();
  return (
    <section
      id="products"
      className="py-24 bg-[#1a0505] text-white relative border-t-8 border-[#c32228]"
    >
      <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/dark-matter.png')]" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col md:flex-row items-end justify-between mb-16 gap-6 border-b border-white/10 pb-8">
          <div>
            <h2 className="text-4xl md:text-6xl font-serif text-white mb-2">
              {t("home.productsTitle")}
            </h2>
            <p className="text-gray-400 font-light">{t("home.productsSubtitle")}</p>
          </div>

          <button
            className="text-[#c32228] hover:text-white transition-colors flex items-center gap-2 font-bold pb-2"
            onClick={() => onNavigate && onNavigate("products")}
            type="button"
          >
            {t("home.fullMenu")} <ArrowLeft size={18} />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              role="button"
              tabIndex={0}
              onClick={() => {
                // ✅ افتح المودال إذا موجود
                if (onProductClick) return onProductClick(product);

                // ✅ fallback للسلوك القديم
                if (onNavigate) onNavigate("products");
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  if (onProductClick) return onProductClick(product);
                  if (onNavigate) onNavigate("products");
                }
              }}
              className="group relative bg-white border border-[#c32228] rounded-sm overflow-hidden hover:shadow-[0_0_20px_rgba(195,34,40,0.2)] transition-all duration-500 cursor-pointer"
            >
              <div
                className="relative h-60 overflow-hidden border-b border-[#c32228]/10"
                // حتى ما يصير تحديد نص/سحب مزعج
                style={{ userSelect: "none" }}
              >
                {Array.isArray(product.images) && product.images.length > 1 ? (
                  <div
                    className="flex h-full w-full overflow-x-auto gap-2 scrollbar-thin scrollbar-thumb-[#c32228]/40 scrollbar-track-transparent"
                  // خليه بس للعرض (الضغط على أي مكان بالكرت يفتح المودال)
                  >
                    {product.images.map((img, idx) => (
                      <img
                        key={img.id || idx}
                        src={
                          img.url ||
                          "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?w=600"
                        }
                        alt={product.name + " " + (idx + 1)}
                        className="h-full w-auto max-w-full object-cover rounded transition-transform duration-700 group-hover:scale-110"
                        style={{ minWidth: "100%" }}
                        draggable={false}
                      />
                    ))}
                  </div>
                ) : (
                  <img
                    src={
                      product.primaryImageUrl ||
                      product.image ||
                      "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?w=600"
                    }
                    alt={product.name}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 will-change-transform"
                    draggable={false}
                  />
                )}

                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm text-[#8a1c20] text-[10px] font-bold px-3 py-1 uppercase tracking-widest border border-[#c32228]/20 shadow-sm">
                  {product.category}
                </div>
              </div>

              <div className="p-6 relative">
                <h3 className="text-xl font-serif font-bold text-[#121212] mb-3 group-hover:text-[#c32228] transition-colors">
                  {product.name}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-6">
                  {product.description}
                </p>

                <div className="flex items-end mt-auto pt-4 border-t border-dashed border-gray-200">
                  <div className="flex flex-col">
                    <span className="text-[10px] text-gray-400 uppercase tracking-wider mb-1">
                      {t("home.price")}
                    </span>
                    <div className="flex items-baseline gap-1 text-[#c32228]">
                      <span className="text-3xl font-serif font-bold">
                        {product.price}
                      </span>
                      <span className="text-xs font-medium text-gray-500">
                        {product.currency}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
